<template>
  <div>


    <div class="box">

      <div class="flex flex-wrap items-center">
        <filtering-toggle-button :filtering="filtering" />

        <div class="flex-grow mb-1">
          <list-search v-model="searchInput" @search="getVehicles" />
          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>

        <div class="flex">
          <div
            v-if="hasPermission('vehicle.create')"
            class="btn btn-purple text-sm mr-2 h-10 flex items-center px-3 mb-1"
            @click="$router.push({ name: 'vehicle.create', params: customerID ? {customerID} : {} })"
          >
            <i class="fas fa-plus"></i>
            <span class="ml-2">New vehicle</span>
          </div>

          <button
            v-if="hasPermission('vehicle.export')"
            type="button"
            class="btn btn-green text-sm px-3 flex items-center mb-1"
            :disabled="!exportFile.vehicle.enabled"
            @click="exportVehicles"
          >
            <i class="fas fa-spinner fa-spin mr-2" v-if="!exportFile.vehicle.enabled"></i>
            <span>Export</span>
          </button>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="getVehicles">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap">
        <div
          class="w-full lg:w-2/12 pr-2 pt-4 border-r border-theme-darker"
          v-show="filtering.active"
        >
          <vehicle-filters
            :filters.sync="filters"
            @updated="getVehicles"
            @has-changes="filtering.hasChanges = $event"
          />
        </div>

        <div class="w-full overflow-x-auto" :class="{ 'lg:w-10/12': filtering.active}">
          <p class="text-lg text-center my-12" v-if="!hasVehicles">No data to display</p>
          <div v-else>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th v-if="showCustomerColumn">Owner</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Plate number</th>
                  <th>Created at</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(vehicle, i) in vehicles" :key="i">
                  <td class="font-bold">{{ vehicle.id }}</td>
                  <td v-if="showCustomerColumn">{{ vehicle.owner }}</td>
                  <td>{{ vehicle.make }}</td>
                  <td>{{ vehicle.model }}</td>
                  <td>{{ vehicle.plate_numbers }}</td>
                  <td class="text-xs">{{ $moment(vehicle.created_at).format(config.dateTimeFormats.display) }}</td>
                  <td>
                    <div class="flex">
                      <a
                        class="hover:text-theme-darker text-base cursor-pointer p-2"
                        @click.stop="$router.push('/vehicle/details/' + vehicle.id)"
                      ><i class="fas fa-info"></i></a>
                      <a
                        class="hover:text-theme-darker text-base cursor-pointer p-2"
                        @click.stop="$router.push('/vehicle/edit/' + vehicle.id)"
                        v-if="hasPermission('vehicle.edit')"
                      ><i class="fas fa-edit"></i></a>
                      <a
                        class="hover:text-theme-darker text-base cursor-pointer p-2"
                        @click.stop="deleteVehicle(vehicle.id)"
                        v-if="hasPermission('vehicle.delete')"
                      ><i class="fas fa-trash"></i></a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="w-full flex justify-center">
          <pagination-component
            class="mt-8"
            v-if="hasVehicles && pagination.totalRows / pagination.perPage > 1"
            v-model="pagination.currentPage"
            :total-rows="pagination.totalRows"
            :rows-per-page="pagination.perPage"
          />
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ListSearch = resolve => require(['@/components/ListSearch'], resolve)
const PaginationComponent = resolve => require(['@/components/Pagination'], resolve)
const FilteringToggleButton = resolve => require(['@/components/filters/FilteringToggleButton'], resolve)
const VehicleFilters = resolve => require(['@/components/filters/Filters'], resolve)


export default {
  name: 'vehicle-list',
  props: {
    customerID: {},
    showCustomerColumn: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FilteringToggleButton,
    ListSearch,
    PaginationComponent,
    VehicleFilters,
  },
  data() {
    return {
      vehicles: [],
      searchInput: '',
      query: {
        search: '',
      },
      exportFile: {
        vehicle: {
          enabled: true,
        }
      },
      filtering: {
        active: false,
        hasChanges: false,
      },
      filters: {
        make: {
          key: 'make',
          name: 'Make',
          active: true,
          modelSelect: {
            propData: {
              model: 'make',
              formName: 'filter-make',
              list: [],
              searchOnMount: true,
              isTaggable: false,
              noWrap: true,
              label: '',
              trackBy: '',
              loading: false,
            },
            listeners: {
              input: (value) => {
                this.filters.make.value = value
              },
              'update:list': (list) => this.filters.make.modelSelect.propData.list = list,
              search: (query) => {
                this.filters.make.modelSelect.propData.list = []
                this.filters.make.modelSelect.propData.loading = true
                axios.get('vehicles/car/make', {params: {query}})
                  .then(response => {
                    const makes = []
                    for (let i in response.data) {
                      makes.push(response.data[i].make)
                    }
                    this.filters.make.modelSelect.propData.list = makes
                    this.filters.make.modelSelect.propData.loading = false
                  })
                  .catch(() => {
                    this.filters.make.modelSelect.propData.loading = false
                  })
              }
            }
          },
          value: null,
        },
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      }
    }
  },
  watch: {
    'pagination.currentPage'() {
      this.getVehicles()
    },
    searchInput(i) {
      if (i === '' && this.query.search !== '') {
        this.getVehicles()
      }
    }
  },
  computed: {
    hasVehicles() {
      return Object.entries(this.vehicles).length > 0
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.getVehicles()
  },
  methods: {
    exportVehicles() {
      let filters = this.$getFilterValues(this.filters)
      if (filters.created_at) {
        let createdAt = this.$getRangeDates(filters.created_at, this.config)
        filters.dateFrom = createdAt.from
        filters.dateTo = createdAt.to
      }
      if (this.customerID) {
        filters.contact_id = this.customerID
      }

      this.exportFile.vehicle.enabled = false
      axios.get('vehicles/export', {
        params: {
          search: this.searchInput,
          filters,
        },
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.$downloadFile(response)
          this.exportFile.vehicle.enabled = true
        })
    },
    deleteVehicle(vehicleID) {
      this.$swal.fire({
        title: 'Delete vehicle',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('vehicles/' + vehicleID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.getVehicles()
              })
          }
        })
    },
    getVehicles() {
      let filters = this.$getFilterValues(this.filters)
      if (filters.created_at) {
        let createdAt = this.$getRangeDates(filters.created_at, this.config)
        filters.dateFrom = createdAt.from
        filters.dateTo = createdAt.to
      }
      if (this.customerID) {
        filters.contact_id = this.customerID
      }

      axios.get('vehicles', {params:{
        page: this.pagination.currentPage,
        search: this.searchInput,
        filters,
      }})
        .then(response => {
          if (response.data) {
            const res = response.data
            this.pagination.perPage = res.per_page
            this.pagination.totalRows = res.total
            this.vehicles = Object.assign({}, res.data)

            this.query.search = this.searchInput
          }
        })
    }
  }
}
</script>
